module.exports = __webpack_public_path__ + "75a6a3b206f99ea9df0057efc9f97c7b.png";